// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__C-PAy","author":"Table_author__qic-M","authorImage":"Table_authorImage__ZmH87","unreadRow":"Table_unreadRow__2ksbT"};